import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";

export interface CustomerWebhook {
  id: number;
  name: string;
  token: string;
  last_used_at: string | null;
  revoked_at: string | null;
  skip_welcome_email: boolean;
}

class WebhookService {
  private getAuthHeaders() {
    return {
      Authorization: getAuthUser()?.accessToken,
    };
  }

  async getWebhook(): Promise<CustomerWebhook> {
    const response = await axios.get(
      `${getApiUrlWithVersion()}/customer_webhook`,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async updateWebhookName(webhookId: number, name: string): Promise<CustomerWebhook> {
    const response = await axios.patch(
      `${getApiUrlWithVersion()}/customer_webhook/${webhookId}`,
      { webhook: { name } },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async updateWebhookSkipWelcomeEmail(webhookId: number, skipWelcomeEmail: boolean): Promise<CustomerWebhook> {
    const response = await axios.patch(
      `${getApiUrlWithVersion()}/customer_webhook/${webhookId}`,
      { webhook: { skip_welcome_email: skipWelcomeEmail } },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }
}

export default new WebhookService();
